import { useMemo } from 'react';
import type { AppStats, CheckinEntry, EventLogEntry } from '../appTypes';

interface UseAppStatsInput {
  checkinEntries: readonly CheckinEntry[];
  eventLogEntries: readonly EventLogEntry[];
  goals: readonly unknown[];
  completedGoals: readonly unknown[];
  edCheckins: readonly unknown[];
  edVisitHistory: readonly unknown[];
  streak: number;
  articlesVisited: boolean;
}

export function useAppStats({
  checkinEntries,
  eventLogEntries,
  goals,
  completedGoals,
  edCheckins,
  edVisitHistory,
  streak,
  articlesVisited,
}: UseAppStatsInput): AppStats {
  return useMemo(
    () => ({
      totalCheckins: checkinEntries.length,
      streak,
      eventsLogged: eventLogEntries.length,
      edCheckins: edCheckins.length,
      articlesVisited,
      edVisits: edVisitHistory.length,
      goalsAdopted: goals.length,
      goalsCompleted: completedGoals.length,
    }),
    [
      checkinEntries,
      eventLogEntries,
      goals,
      completedGoals,
      edCheckins,
      edVisitHistory,
      streak,
      articlesVisited,
    ]
  );
}
